import { SvgIcon } from '@mui/material';

const PencilEdit = () => (
  <SvgIcon
    viewBox="0 0 20 20"
    xmlns="http://www.w3.org/2000/svg"
    sx={{ width: 20, height: 20, fill: 'none' }}
    data-testid="pencilEditIcon"
    titleAccess="edit"
  >
    <path
      d="M0.0562519 19.9438L0.000280653 16.579C-0.00884848 16.0302 0.205072 15.5011 0.593124 15.1128L12.2385 3.45989L16.5334 7.75357L4.88881 19.4057C4.5003 19.7945 3.97052 20.0089 3.42089 19.9997L0.0562519 19.9438Z"
      fill="#115DC4"
    />
    <path
      d="M15.1056 0.593623C15.8973 -0.197874 17.1809 -0.197874 17.9727 0.593623L19.4062 2.02676C20.1979 2.81825 20.1979 4.10152 19.4062 4.89302L17.9727 6.32615L13.672 2.02676L15.1056 0.593623Z"
      fill="#115DC4"
    />
  </SvgIcon>
);

export default PencilEdit;
